<template>
    <div class="sample">
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </div>
</template>

<script>
export default {
    name: 'sample',
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/sample/sample.vue